<template lang="pug">
div
  el-card(shadow='hover').card-collapse
    app-header-dados-processo(
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").card-container
    div
      el-steps.card-container(:active='active', finish-status='success', simple)
        el-step(title='Informar dados do VTN')
        el-step(title='Confirmar dados VTN')

      validation-observer(ref='validation' tag='div', v-if="active === 0")
        div(v-if="active === 0")
          InformarDados(
            :vtnRequest="vtnRequest",
            @setDados="setDados"
          )
      div(v-if="active === 1")
        ConfirmarDados(
          :dadosVtn="dadosVtn",
          :processo="proc"
        )

      el-card(shadow="hover",v-if="true").card-collapse
        validation-observer(ref='validation' tag='div')
          validation-provider(rules="required", v-slot="{ errors }")
            .flex-despacho
              p.label Despacho
                span.required &nbsp * &nbsp
              el-button(type="primary", @click="openModalDespacho") Modelo &nbsp
                .fa.fa-file
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="despacho.textoDespacho",
              ref="editorTexto",
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )

      validation-observer.flex-around(ref='validaAcaoSelecionada' tag='div')
        app-radios-tramitacao(
          :radios="tarefa.acoes",
          :isDecisao="true",
          :isEsconderEncaminhamento="true"
          @changeRadio="changeRadio",
          :radioInicial="acao",
          v-if="tarefa && tarefa.acoes && active === 1"
        )

      app-buttons-cadastro(
        :showButtonCancelar='true',
        :showButtonProximo='true',
        :showButtonSalvar='true',
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="isPrimeiroPasso",
        @proximo="proximo",
        @voltar="voltar",
        @cancelar='cancelar',
        @finalizar='finalizar',
        @salvar='salvar'
      )
  app-modal-selecionar-modelo-notificacao(
      v-if="showModalDespacho",
      :tiposModelo="tiposModelo",
      :titulo="tituloModalModelo",
      :idProcesso="processo.id"
      :showModal="showModalDespacho"
      @closeModal="fecharModalDespacho",
      @setTextoDespacho="setTextoDespacho"
    )
</template>

<script>
import { mapActions } from 'vuex'
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import ConfirmarDados from './components/ConfirmarDados.vue'
import ConfirmarDadosRR from './components/ConfirmarDadosRR.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import InformarDados from './components/InformarDados.vue'
import InformarDadosRR from './components/InformarDadosRR.vue'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto.vue'
import AppModalSelecionarModeloNotificacao from '@/screens/analise/components/AppModalSelecionarModeloNotificacao.vue'
import AppAnexo from '@/components/AppAnexo.vue'

const {
  tiposModeloDefault
} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppHeaderDadosProcesso,
    InformarDados,
    AppButtonsCadastro,
    ConfirmarDados,
    ConfirmarDadosRR,
    InformarDadosRR,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppModalSelecionarModeloNotificacao,
    AppAnexo
  },

  props: {
    processo: {
      type: Object,
      required: true
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      active: 0,
      isCCR: false,
      proc: null,
      acao: '',
      tarefa: null,
      municipio: {
        id: '',
        nome: ''
      },
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      vtnRequest: {
        // dados de RR
        areaTotalImovelGeorreferenciado: '',
        gleba: '',
        tempoOcupacao: '',
        distanciaBoaVista: '',
        condutaLesivaMeioAmbiente: false,
        // dados do AP e comuns à ambos
        areaRequerida: '',
        moduloFiscal: '',
        nModuloFiscal: '',
        coeficienteAngular: '',
        coeficienteLinear: '',
        percentualCalculado: 0,
        percentualAplicado: '',
        valorFinalImovel: '',
        municipio: {
          id: null,
          nome: ''
        },
        pvtn: {
          vtnPorHaMinFormatado: ''
        },
        municipiosRR: []
      },
      dadosVtn: {},
      dadosCadastro: '',
      json: {},
      despacho: {
        textoDespacho: '',
        documentos: []
      },
      anexos: [],
      showModalDespacho: false,
      tituloModalModelo: 'Modelos de Despacho',
      tiposModelo: tiposModeloDefault // Despacho
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.active === 0
    },
    isUltimoPasso () {
      return this.active === 1
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  },

  async created () {
    this.proc = await this.getProcesso(this.processo.numeroProtocolo)
    await this.montarTela()
  },

  methods: {
    ...mapActions({
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      getProcesso: 'processos/getProcessoByProtocolo',
      createVtn: 'vtn/createVtn',
      updateVtn: 'vtn/updateVtn',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      tramitarComAcao: 'processo/tramitarComAcao',
      finalizarVtnAP: 'vtn/finalizarVtnAP',
      criarDespacho: 'vtn/criarDespacho',
      getTarefa: 'processo/tarefa',
      findUltimoByIdProcesso: 'despacho/findUltimoByIdProcesso'
    }),
    async finalizar () {
      const valido = await this.$refs.validaAcaoSelecionada.validate()
      const despachoValido = await this.$refs.validation.validate()
      if (!valido || !despachoValido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_SIMULAR_VTN
        )
        return
      }
      await this.salvar()
      this.tramitaComAcao()
    },
    changeRadio (value) {
      this.acao = value.acao
    },
    cancelar () {
      this.goToListagem()
    },
    goToListagem () {
      this.$router.push({
        name: 'CAIXA_ENTRADA'
      })
    },

    openModalDespacho () {
      this.showModalDespacho = true
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },

    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },

    onTextChange (text) {
      this.despacho.textoDespacho = text
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    async salvar () {
      try {
        this.despacho.documentos = this.anexos

        const dados = {
          despacho: this.despacho,
          processoId: this.proc.id
        }
        await this.criarDespacho(dados)

        let ultimoDespacho = await this.findUltimoByIdProcesso(this.proc.id)

        this.despacho = {
          id: ultimoDespacho.id,
          textoDespacho: ultimoDespacho.textoDespacho,
          documentos: ultimoDespacho.documentos
        }

        this.anexos = ultimoDespacho.documentos

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_SALVAR_DESPACHO
        )
      }
    },

    async montarTela () {
      this.dadosVtn = await this.getVtnByIdProcesso(this.proc.id)
      this.tarefa = await this.getTarefa({processo: this.proc.id})
      let ultimoDespacho = await this.findUltimoByIdProcesso(this.proc.id)

      if (ultimoDespacho.tipo === 'VTN' || ultimoDespacho.tipo === 'RESPOSTA_REVISAO') {
        this.despacho = {
          id: ultimoDespacho.id,
          textoDespacho: ultimoDespacho.textoDespacho,
          documentos: ultimoDespacho.documentos
        }

        this.anexos = ultimoDespacho.documentos
      }

      if (this.proc.municipios[0] != null) {
        this.municipio = this.proc.municipios[0]
      } else if (this.proc.dadosCadastro.dados.cadastro.qualificacao.municipio) {
        this.municipio = this.proc.dadosCadastro.dados.cadastro.qualificacao.municipio
      } else if (this.proc.dadosCadastro.dados.cadastro.imovel.municipio != null) {
        this.municipio = this.proc.dadosCadastro.dados.cadastro.imovel.municipio
      } else if (this.dadosVtn?.pvtn?.municipio) {
        this.municipio = this.dadosVtn.pvtn.municipio
      }

      let pvtn = null
      if (this.municipio.id) {
        pvtn = await this.getPvtnAtivo(this.municipio.id)
      }

      if (this.dadosVtn) {
        this.vtnRequest = {
          ...this.vtnRequest,
          gleba: this.dadosVtn.gleba,
          tempoOcupacao: this.dadosVtn.tempoOcupacao,
          areaTotalImovelGeorreferenciado: this.dadosVtn.areaTotalImovelGeorreferenciado,
          distanciaBoaVista: this.dadosVtn.distanciaBoaVista,
          id: this.dadosVtn.id,
          idProcesso: this.proc.id,
          processo: {
            id: this.proc.id
          },
          areaRequerida: this.dadosVtn.areaRequerida,
          nModuloFiscal: this.dadosVtn.nModuloFiscal || this.dadosVtn.nmoduloFiscal,
          coeficienteAngular: this.dadosVtn.coeficienteAngular,
          coeficienteLinear: this.dadosVtn.coeficienteLinear,
          percentualAplicado: this.dadosVtn.percentualAplicado,
          percentualCalculado: this.dadosVtn.percentualAplicado * 100,
          valorFinalImovel: this.isEstadoAP ? this.dadosVtn.valorFinalImovel : this.valorFinalFormatado(),
          moduloFiscal: pvtn ? pvtn.municipio.mf : null,
          municipio: {
            id: this.municipio.id,
            nome: this.municipio.nome
          },
          pvtn: pvtn
        }
      } else {
        this.vtnRequest = {
          ...this.vtnRequest,
          idProcesso: this.proc.id,
          processo: {
            id: this.proc.id
          },
          gleba: '',
          areaRequerida: this.proc?.dadosCadastro?.dados?.cadastro?.qualificacao?.area,
          nModuloFiscal: this.getModuloFiscal(pvtn),
          coeficienteAngular: '',
          coeficienteLinear: '',
          percentualAplicado: '',
          valorFinalImovel: this.valorFinalImovel ? this.valorFinalImovel : '',
          moduloFiscal: pvtn ? pvtn.municipio.mf : null,
          municipio: this.municipio,
          pvtn: pvtn
        }
      }
    },
    getModuloFiscal (pvtn) {
      if (pvtn) {
        if (typeof this.proc?.dadosCadastro?.dados?.cadastro?.qualificacao?.area !== 'string') {
          return this.proc?.dadosCadastro?.dados?.cadastro?.qualificacao?.area / pvtn.municipio.mf
        }
        return parseFloat(this.proc?.dadosCadastro?.dados?.cadastro?.qualificacao?.area.replaceAll(',', '.')) / pvtn.municipio.mf
      }
      return 0
    },
    async proximo () {
      if (this.active === 0 && (this.vtnRequest.areaRequerida === 0 || this.vtnRequest.percentualCalculado > 100)) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VALIDATION_FAIL
        )
        return
      }
      if (!this.dadosVtn.id) {
        this.vtnRequest.qtdModuloFiscal = this.vtnRequest.nModuloFiscal
        this.dadosVtn = await this.createVtn(this.vtnRequest)
        this.dadosVtn.processo = {
          id: this.proc.id,
          numeroProcesso: this.proc.numeroProcesso,
          municipio: this.proc.municipios[0]
        }
        this.dadosVtn.condutaLesivaMeioAmbiente = this.vtnRequest.condutaLesivaMeioAmbiente
        this.dadosVtn.distanciaBoaVista = this.vtnRequest.distanciaBoaVista
        this.dadosVtn.tempoOcupacao = this.vtnRequest.tempoOcupacao
        this.vtnRequest.id = this.dadosVtn.id
      } else {
        this.vtnRequest.qtdModuloFiscal = this.vtnRequest.nModuloFiscal
        this.vtnRequest.id = this.dadosVtn.id
        this.dadosVtn = await this.updateVtn(this.vtnRequest)
        this.vtnRequest.valorFinalImovel = this.dadosVtn.valorFinalImovel
        this.vtnRequest.valorFinalImovelFormatado = this.dadosVtn.valorFinalImovelFormatado
        this.dadosVtn.processo = {
          id: this.proc.id,
          numeroProcesso: this.proc.numeroProcesso,
          municipio: this.proc.municipios[0]
        }
      }
      this.active = this.active + 1
    },
    voltar () {
      this.active = this.active - 1
    },
    async tramitaComAcao () {
      this.despacho.documentos = this.anexos

      if (this.processo.perfil === 'ANALISTA') {
        await this.finalizarVtnAP({
          processoId: this.vtnRequest.processo.id,
          acao: this.acao,
          despacho: this.despacho
        }).then(setorNovo => {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.PROCESSOS_ENCAMINHADOS.replace('$$', setorNovo)
          )
          this.goToListagem()
        })
      } else {
        await this.finalizarVtnAP({
          processoId: this.vtnRequest.processo.id,
          acao: this.acao,
          despacho: this.despacho
        }).then((setorNovo) => {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.PROCESSOS_ENCAMINHADOS.replace('$$', setorNovo)
          )
          this.goToListagem()
        })
      }
    },
    valorFinalFormatado () {
      let formatado = this.vtnRequest.valorFinalImovel.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return formatado
    },
    async setDados (dados) {
      this.municipio = {
        id: dados.municipio.id,
        nome: dados.municipio.nome
      }

      let pvtn = null
      pvtn = await this.getPvtnAtivo(dados.municipio.id)

      this.vtnRequest = {
        ...this.vtnRequest,
        areaRequerida: dados.areaRequerida,
        municipio: this.municipio,
        nModuloFiscal: pvtn ? dados.areaRequerida / pvtn.municipio.mf : 0,
        moduloFiscal: pvtn ? pvtn.municipio.mf : null,
        pvtn
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 20px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.required {
  color: firebrick;
}

.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/cadastrarVtn.vue